import { render, staticRenderFns } from "./AddFireProtection.vue?vue&type=template&id=223b541c&scoped=true"
import script from "./AddFireProtection.vue?vue&type=script&lang=js"
export * from "./AddFireProtection.vue?vue&type=script&lang=js"
import style0 from "./AddFireProtection.vue?vue&type=style&index=0&id=223b541c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223b541c",
  null
  
)

export default component.exports